import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import MainMenu from "./pages/MainMenu";
import Rules from "./pages/Rules";
import Game from "./pages/Game";
import MultiplayerLobby from "./pages/MultiplayerLobby";
import MultiplayerGame from "./pages/MultiplayerGame";
import InvitePage from "./pages/InvitePage";
import Profile from "./pages/Profile";
import LeagueDashboard from "./pages/LeagueDashboard";
import LeagueMatchSpectator from "./pages/LeagueMatchSpectator";
import { AnimatePresence } from "framer-motion";
import Modal from "./components/UI/modal/Modal";
import MenuWrapper from "./components/UI/menuWrapper/MenuWrapper";
import GameMenuContext from "./components/game/gameMenuContext/GameMenuContext";
import { useAppSelector } from "./store/hooks";
import { selectIsModalOpened } from "./store/modalSlice";
import { selectGameIsRunning } from "./store/gameSlice";
import DifficaltyGameModalContent from "./components/UI/difficultyModalContent/DifficultyGameModalContent";
import { FarcasterProvider } from "./contexts/FarcasterContext";

function App() {
  const location = useLocation();
  const isOpenModal = useAppSelector(selectIsModalOpened);
  const gameIsRunning = useAppSelector(selectGameIsRunning);

  return (
    <FarcasterProvider>
      <div className="app">
        <AnimatePresence mode="wait" initial={false}>
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<MainMenu />} />
            <Route path="/rules" element={<Rules />} />
            <Route
              path="/game"
              element={gameIsRunning ? <Game /> : <MainMenu />}
            />
            <Route path="/multiplayer" element={<MultiplayerLobby />} />
            <Route path="/multiplayer/game" element={<MultiplayerGame />} />
            {/* Dynamic invite page — shareable link */}
            <Route path="/join/:code" element={<InvitePage />} />
            {/* Player profile + leaderboard */}
            <Route path="/profile" element={<Profile />} />
            {/* AI League Dashboard */}
            <Route path="/league" element={<LeagueDashboard />} />
            {/* AI League — read-only live match spectator */}
            <Route path="/league/match/:seriesId" element={<LeagueMatchSpectator />} />
            <Route path="*" element={gameIsRunning ? <Game /> : <MainMenu />} />
          </Routes>
        </AnimatePresence>
        <AnimatePresence>
          {isOpenModal.gameMenu && (
            <Modal key="gameMenuModal">
              <MenuWrapper type="gameMenu">
                <GameMenuContext />
              </MenuWrapper>
            </Modal>
          )}
          {isOpenModal.mainMenu && (
            <Modal key="mainMenuModal">
              <DifficaltyGameModalContent />
            </Modal>
          )}
        </AnimatePresence>
      </div>
    </FarcasterProvider>
  );
}

export default App;
